import * as React from "react";
import type { SVGProps } from "react";
const SvgMoodSmileHappy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 12C2 6.49 6.49 2 12 2s10 4.49 10 10-4.49 10-10 10S2 17.51 2 12m2 0c0 4.41 3.59 8 8 8s8-3.59 8-8-3.59-8-8-8-8 3.59-8 8m6.45-1.11c-.15.08-.3.11-.45.11l.03-.01c-.37 0-.72-.2-.9-.55-.04-.07-.25-.2-.61-.2s-.58.13-.61.2c-.25.5-.85.7-1.34.45-.5-.25-.7-.85-.45-1.34.4-.8 1.32-1.3 2.39-1.3s1.99.5 2.39 1.3c.24.49.04 1.09-.45 1.34m7.44-1.34c-.4-.8-1.32-1.3-2.39-1.3s-1.99.5-2.39 1.3a.993.993 0 0 0 .45 1.34c.49.25 1.09.05 1.34-.45.03-.07.25-.2.61-.2s.57.13.61.2a1.007 1.007 0 0 0 1.35.44c.49-.25.69-.85.45-1.34zm-7.63 4.79c.98.96 2.57.95 3.53-.04.39-.39 1.02-.4 1.42-.01.39.39.4 1.03.01 1.42a4.46 4.46 0 0 1-3.17 1.35H12c-1.19 0-2.3-.46-3.15-1.29-.39-.39-.4-1.03-.01-1.42s1.02-.4 1.42-.01"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMoodSmileHappy;
